module.exports = __webpack_public_path__ + "static/img/Head of home-03.b28c4e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/issue14/The head of home/Head of home-03.jpg
// module id = mPZr
// module chunks = 7